const AnalyticsService = {
  getAnalytics: async (id = '') => {
    const { data } = await ovpFetch(`https://api.streamify.io/analytics?content_id=${id}`);
    return data;
  },
  range: async (id, start, end) => {
    const { data } = await ovpFetch(`https://api.streamify.io/analytics?content_id=${id}&start=${start}&end=${end}`);
    return data;
  },
  /**
   * Get range statistics for broadcast with ID and FROM and TO dates
   * @param {String} id
   * @param {String} from
   * @param {String} to
   * @returns {Object}
   */
  getAccountStatistics: async (from, to = null) => {
    const { data } = await ovpFetch(`/statistics/account?start=${from}${to !== null ? `&end=${to}` : ''}`);
    return data;
  },
  /**
   * Get total statistics for account
   * @returns {Object}
   */
  getAccountTotalStatistics: async () => {
    const { data } = await ovpFetch('/statistics/account/total');
    return data;
  },
  /**
   * Get range statistics for broadcast with ID and FROM and TO dates
   * @param {String} id
   * @param {String} from
   * @param {String} to
   * @returns {Object}
   */
  getBroadcastStatistics: async (id, from, to = null) => {
    if (!id) {
      return {};
    }

    const { data } = await ovpFetch(`/statistics/broadcast/${id}?start=${from}${to !== null ? `&end=${to}` : ''}`);
    return data;
  },
  /**
   * Get total statistics for broadcast with ID
   * @param {String} id
   * @returns {Array}
   */
  getBroadcastTotalStatistics: async (id) => {
    if (!id) {
      return {};
    }

    const { data } = await ovpFetch(`/statistics/broadcast/${id}/total`);
    return data;
  },
  /**
   * Get transactions for period of time
   * @param {String} start
   * @param {String} end
   * @returns {Array}
   */
  getTotalRevenueForPeriod: async (start, end) => {
    const { data } = await ovpFetch(`/transactions?start=${start}&end=${end}&per_page=10000&type=stripe,stripe_donation,swish&status=completed,pending_transfer`).catch(() => false);
    return data;
  },
  /**
   * Get broadcast live timeline
   * @param {String} id
   * @returns {Object}
   */
  getBroadcastLiveStatistics: async (id) => {
    if (!id) {
      return {};
    }

    const { data } = await ovpFetch(`/statistics/broadcast/${id}/timeline`);
    return data;
  },
};

// eslint-disable-next-line
export { AnalyticsService }
